import React from "react";
import "../styles/LatestArticle.css";
import img1 from "../assets/jaipur.webp";
import img2 from "../assets/kerala.webp";
import img3 from "../assets/dubaiuae.webp";
import {Link} from "react-router-dom";

const articleData = [
  {
    img: img1,
    description: "Explore Rajasthan’s royal palaces, historic forts, vibrant markets, and rich cultural heritage with an unforgettable week-long travel and cultural tour experience.",
    location: "Jaipur, Rajasthan",
    link: "https://plankarotrip.blogspot.com/2025/07/header.html"
  },{
    img: img3,
description: "Experience Dubai’s luxury lifestyle with visits to the iconic Burj Khalifa, thrilling desert safari adventures, stunning city attractions, shopping experiences, and relaxing dhow cruises.",
  location: "Dubai, UAE",
    link: "https://plankarotrip.blogspot.com/2025/07/header.html"
  },
  {
    img: img2,
description: "Discover Kerala’s scenic backwaters, beautiful beaches, lush hill stations, and breathtaking natural landscapes with unforgettable nature tours, houseboat stays, and relaxing travel experiences.",    location: "Alleppey, Kerala",
     link: "https://plankarotrip.blogspot.com/2025/07/header.html"
  }
];

const LatestArticle = () => {
  return (
    <div className="Article-section">
      <div className="Article-header">
        <h2 className="Article-title">From The Blog Post</h2>
        <h3 className="Article-subtitle">Latest News & Articles</h3>
      </div>

      <div className="Article-grid">
        {articleData.map((tour, i) => (
          <div className="Article-card" key={i}>
            <div className="Article-image">
              <img src={tour.img} alt={`Tour ${i + 1}`} />
                          </div>
            <div className="Article-details">
              <p className="description">{tour.description}</p>
              <p className="location">{tour.location}</p>
            </div>
           <div className="readme-button">
  <Link to={tour.link}>
    <button className="button">Read More →</button>
  </Link>
</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LatestArticle;
